import { render, staticRenderFns } from "./TheCollapse.vue?vue&type=template&id=77d868bf&scoped=true"
import script from "./TheCollapse.vue?vue&type=script&lang=js"
export * from "./TheCollapse.vue?vue&type=script&lang=js"
import style0 from "./TheCollapse.vue?vue&type=style&index=0&id=77d868bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d868bf",
  null
  
)

export default component.exports